import {
  wellbeingMaterialsSearchSchema,
  wellbeingMaterialsViewColumns,
  mapWellbeingMaterialsViewQuery,
} from "./WellbeingMaterialsView.default";
import ManagedGridView from "../../controls/ManagedGridView";
import { SearchQuery } from "../../code/search-query/search-query";
import { getWellbeingMaterials } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface WellbeingMaterialsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function WellbeingMaterialsView(props: WellbeingMaterialsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={wellbeingMaterialsViewColumns}
      schema={wellbeingMaterialsSearchSchema}
      mapQuery={mapWellbeingMaterialsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getWellbeingMaterials, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "update",
          label: "Edit",
          disabled: !permissions.can("WellbeingCorner", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("WellbeingCorner", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default WellbeingMaterialsView;
